import { Sun, Moon } from "lucide-react";

// Modernized from the old fixed-icon pill (two static Fa* icons that
// just faded in/out on either side of the track while a plain white
// knob slid past them) to an icon-in-the-knob switch: the knob itself
// carries whichever icon is active and travels with it, the track uses
// the app's own --vi-* tokens (a flat surface in light mode, the
// accent gradient in dark mode — no glow, on request) instead of
// hardcoded Tailwind blues, and lucide-react (Sun/Moon) matches every
// other icon already used elsewhere in Sidebar.tsx rather than mixing
// in react-icons just for this one control.
const DarkModeSwitcher = ({
  darkMode,
  toggleDarkMode,
}: {
  darkMode: boolean;
  toggleDarkMode: () => void;
}) => (
  <button
    type="button"
    onClick={toggleDarkMode}
    aria-label="Toggle dark mode"
    aria-pressed={darkMode}
    className="relative flex items-center shrink-0 w-14 h-7 rounded-full p-[3px] border transition-colors duration-300"
    style={{
      background: darkMode ? "var(--vi-accent-grad)" : "var(--vi-surface)",
      borderColor: "var(--vi-card-border)",
    }}
  >
    <span
      className={`flex items-center justify-center w-5 h-5 rounded-full bg-white shadow-md transition-transform duration-300 ease-out ${
        darkMode ? "translate-x-7" : "translate-x-0"
      }`}
    >
      {darkMode ? (
        <Moon
          size={12}
          strokeWidth={2.5}
          className="text-[color:var(--vi-accent)]"
        />
      ) : (
        <Sun size={12} strokeWidth={2.5} className="text-amber-500" />
      )}
    </span>
  </button>
);

export default DarkModeSwitcher;
